import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.profiles.profile.extended', {
        url: '/extended',
        component: 'userProfileExtended'
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/extended/extended.state.js